module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Text/Text-height-0a91552ca591802e9f2c44de5cf82da9.svg";